import React from 'react';
import { UserInteractionVariant } from '@naf/user-interaction';
import { useNavigate } from 'react-router-dom';
import { FieldValidationAction } from '@dtp/membership-service-types/dist/form/FieldValidationActionTypes';
import useSelector from '@redux/typedHooks';
import { useLoginRedirect } from '../../../../hooks/useLoginRedirect';
import * as S from './AlreadyAMemberButton.styles';

interface Props {
  path: string;
}

export const AlreadyAMemberButton = ({ path }: Props) => {
  const validationMap = useSelector((state) => state.order.validation?.validationMap);
  const navigate = useNavigate();
  const { redirectToLoginPage } = useLoginRedirect();
  const error = validationMap && validationMap['CustomerProductsRequests[0].Profile.Email'];

  let ctaText = '';
  let ctaAction: () => void;
  const userIsNotAMember = error?.action === FieldValidationAction.LoginCreateMembership;

  // No membership is required for buying IFK, but we want users to log in to their account when they actually have one, in order to register the product order in Dynamics.
  if (userIsNotAMember) {
    ctaText = 'Logg inn';
    ctaAction = async () => {
      redirectToLoginPage('/bli-medlem');
    };
  }

  if (error?.action === FieldValidationAction.LoginMyMembership) {
    ctaText = 'Logg inn';
    ctaAction = async () => {
      redirectToLoginPage(path);
    };
  }

  if (error?.action === FieldValidationAction.LoggedInIsMember) {
    ctaText = 'Prøv igjen';
    ctaAction = async () => {
      navigate(path);
    };
  }

  return (
    (error && (
      <S.StyledUserInteraction
        button={{
          onClick: () => {
            ctaAction();
          },
          children: ctaText,
        }}
        title="Deg har vi sett før"
        variant={UserInteractionVariant.Info}
      >
        {error.message}
      </S.StyledUserInteraction>
    )) ||
    null
  );
};
